import type { SyntaxNode } from 'web-tree-sitter';
import type { SymbolImportBinding } from '../../types.js';
import { pushBinding, stringLiteralText } from './shared.js';

function collectRequireCall(
  out: SymbolImportBinding[],
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
  node: SyntaxNode,
): void {
  const methodNode = node.childForFieldName('method');
  if (!methodNode || (methodNode.text !== 'require' && methodNode.text !== 'require_relative')) return;

  const args = node.childForFieldName('arguments');
  const stringNode = args?.descendantsOfType('string')[0] ?? args?.descendantsOfType('string_content')[0];
  if (!stringNode) return;

  const modulePath = stringLiteralText(stringNode);
  const localName = modulePath.split('/').filter(Boolean).at(-1)?.replace(/\.rb$/, '') ?? modulePath;
  pushBinding(out, filePath, workspaceFiles, modulePath, localName, localName, 'default', stringNode);
}

export function extractRubyImportBindings(
  root: SyntaxNode,
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
): SymbolImportBinding[] {
  const out: SymbolImportBinding[] = [];
  for (const node of root.descendantsOfType('call')) {
    collectRequireCall(out, filePath, workspaceFiles, node);
  }
  return out;
}
